"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate_initial_scenario_level = void 0;
var diveSaver_all_sidecar_1 = require("@dive/saver/diveSaver_all-sidecar");
var diveTilemapGenerator_broguesque_1 = require("./broguesque/diveTilemapGenerator_broguesque");
var diveGeneratorManager_sidecar_1 = require("./common/diveGeneratorManager-sidecar");
var gen_clear_sidecar_1 = require("./common/gen_clear-sidecar");
function generate_initial_scenario_level(isStartingLevel, loadFromSave, levelNum, isSafeRoom) {
    gen_clear_sidecar_1.gen_clear.clearTilemap();
    var options = {
        isStartingLevel: isStartingLevel,
        levelNum: levelNum,
        isSafeRoom: isSafeRoom,
    };
    if (loadFromSave) {
        // Try restoring from save
        if (diveSaver_all_sidecar_1.diveSaver_all.read_fromLocalStorage()) {
            return;
        }
    }
    diveGeneratorManager_sidecar_1.diveGeneratorManager.addGenerator(diveTilemapGenerator_broguesque_1.gen_broguesque_container(options));
}
exports.generate_initial_scenario_level = generate_initial_scenario_level;
